import { render, staticRenderFns } from "./historical.vue?vue&type=template&id=245176e6&scoped=true"
import script from "./historical.vue?vue&type=script&lang=js"
export * from "./historical.vue?vue&type=script&lang=js"
import style0 from "./historical.vue?vue&type=style&index=0&id=245176e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245176e6",
  null
  
)

export default component.exports